import React, { useContext, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Grid,
  TextField,
  Button,
  // IconButton,
  Paper,
} from "@material-ui/core";
import PageHeadingCreate from "../../../components/PageHeadingCreate/index.js";
import PathsandTitle from "../../../common/constants/PathsandTitle.js";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage/index.js";
import {
  create_uom_master,
  list_uom_master,
} from "../../../common/index.js";
import useStyles from "../../../themes/makeStyles.js";
import ActionTypes from "../../../common/constants/ActionTypes.js";
import Notification from "../../../components/Notifications/index.js";
import clsx from "clsx";
import { useHistory } from "react-router-dom";

export default function EditUOMMaster(props) {
  const [resetvalues, setResetvalues] = React.useState(false);
  const userData = JSON.parse(sessionStorage.getItem("login")) || {};

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  let id = props.location.id;

  let defaultValues = {
    id: id,
    uom: "",
    description: "",
  };

  const { handleSubmit, reset, setValue, control, errors } = useForm({
    defaultValues,
  });

  useEffect(() => {
    if (id) {
      list_uom_master({
        id: id.toString(),
      }).then((data) => {
        setValue("id", data.Records[0].id);
        setValue("uom", data.Records[0].uom);
        setValue("description", data.Records[0].description);
      });
    }
  }, []);

  const history = useHistory();

  const onSubmit = async (data) => {
    let postobj = {
      id:id,
      uom: data.uom,
      description: data.description,
      createdby: userData.name,
      record_type_status: true,
    };

    let uomMasterUpdateDeatils = await create_uom_master(
      postobj
    );

    if (uomMasterUpdateDeatils.issuccess === 1) {
      setNotify({
        isOpen: true,
        message: `UOM Master Updated Successfully `,
        type: "success",
        timing: 3000,
      });
      setTimeout(function () {
        history.push(`/${ActionTypes.LOB}/masters/list-uom-master`);
      }, 3000);
    } else if (uomMasterUpdateDeatils.issuccess === 2) {      
        setNotify({
          isOpen: true,
          message: `UOM already exists`,
          type: "error",
          timing: 3000,
        });
    } else if (uomMasterUpdateDeatils.issuccess === 0) {      
      setNotify({
        isOpen: true,
        message: uomMasterUpdateDeatils.message,
        type: "error",
        timing: 3000,
      });
  }
  };

  //return here
  const classes = useStyles();
  return (
    <React.Fragment>
      <PageHeadingCreate
        headingtitle={PathsandTitle.PathsHeading.editUom}
        headingpath={PathsandTitle.TitlesNavigation.uomName}
        pageStatus="Update"
        pagePath="Update UOM Master"
      />
      <Box py={1}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate key={resetvalues}>
          <Paper elevation={0}>
            <Box py={4} px={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="ID"
                    placeholder="ID"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    disabled
                    size="small"
                    name="id"
                    id="id"
                    error={errors.id}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.id && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="ID"
                      name="id"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="UOM"
                    placeholder="UOM"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="uom"
                    id="uom"
                    error={errors.uom}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.uom && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="UOM"
                      name="uom"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Description"
                    placeholder="Description"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="description"
                    id="description"
                    error={errors.description}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.description && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Description"
                      name="description"
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          </Paper>

          <Box py={2}>
            <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={clsx(
                    classes.subTextButton,
                    "mr-0",
                    "btnMinWidthSearch"
                  )}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>

        <Notification notify={notify} setNotify={setNotify} />
      </Box>
    </React.Fragment>
  );
}
